<template>
    <validation-observer v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(changePassword)">
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <uv-text-field v-model="oldPass" name="oldpass" rules="required" :label="$t('labels.oldPassword')"
                        :password="true">
                        </uv-text-field>
                    </v-col>
                    <v-col cols="12">
                        <uv-text-field v-model="newPass"  name="newpass" rules="required|strongpwd" :label="$t('labels.password')"
                        :password="true">
                        </uv-text-field>
                    </v-col>
                    <v-col cols="12">
                        <uv-text-field v-model="confirmPass" name="confirmpass" rules="required|strongpwd" :label="$t('labels.confirmPassword')" 
                        :password="true">
                        </uv-text-field>
                    </v-col>
                </v-row>
                <v-row justify="end">
                    <v-col cols="auto">
                        <uv-button type="submit" color="success" :loading="loading">{{ $t('save')}}</uv-button>
                    </v-col>
                </v-row>
            </v-container>
        </form>
    </validation-observer>
</template>

<script>
export default {
    name: "ChangePasswordForm",
    data() {
        return {
            oldPass: null,
            newPass: null,
            confirmPass: null,
            loading: false
        }
    },
    methods: {
        changePassword(){
            if (this.newPass !== this.confirmPass){
                this.$refs.form.setErrors({
                    confirmpass: [this.$t('labels.passwordsDontMatch')]
                })
            }else{
                this.loading = true;
                this.$apiHttp({
                    url: "/auth/change_password",
                    method: "POST",
                    data: {
                        old_pwd: this.oldPass,
                        new_pwd: this.newPass,
                        confirm_pwd: this.confirmPass,
                    },
                })
                .then(()=>{
                    this.resetForm();
                    this.$store.commit('SET_globalMessage', {type: 'success', message: this.$t('messages.passwordChanged')})
                })
                .finally(() => {
                    this.loading = false;
                });
            }
        },
        resetForm(){
            this.oldPass = ""; this.newPass = ""; this.confirmPass = ""; this.pwdVisible = false;
            this.$refs.form.reset();
        }
    }
}
</script>

<style lang="sss" scoped>

</style>